import React from 'react';
import { ICustomItemsOfGroups } from 'types';
import { useCarouselItemUrl } from '../useCarouselItemUrl';
import LoaderWithProps from 'components/Loader/LoaderWithProps';
import Text from 'components/Text/Text';

interface IProps {
	item: ICustomItemsOfGroups;
	isMakeRequest: boolean;
}

export const CarouselSlideNew: React.FC<IProps> = ({ item, isMakeRequest }) => {
	const { url, isError, showError } = useCarouselItemUrl({ item, photoSize: 'Medium', isMakeRequest });
	const isVideo = item.mediaFileType === 2;

	if (isError) {
		return (
			<div className="h-96 rounded flex items-center justify-center bg-purple-01-new" data-test="SlideError">
				<Text
					translationNameSpace="form"
					translationKey={isVideo ? 'videoLoadError' : 'imageLoadError'}
					theme="neutralMedium"
					size="xs"
				/>
			</div>
		);
	}

	if (!url) {
		return (
			<div className="relative h-96 rounded overflow-hidden">
				<LoaderWithProps loaderSize="big" />
			</div>
		);
	}

	return (
		<div className="h-96 flex items-center justify-center" data-test="CarouselSlide">
			{isVideo ? (
				<video className="max-w-full max-h-full" src={url} controls={true} onError={showError} />
			) : (
				<img className="max-w-full max-h-full" src={url} alt="Photo" onError={showError} />
			)}
		</div>
	);
};
